// ---------------------------------------------------------------------------
// Pie chart renderer — Konva-pure so it can be used by block renderers
// (renderers/chart.js) and server-side rendering without importing the full
// RenderHelpers module.
// ---------------------------------------------------------------------------
import Konva from "konva";
import { categoryColors } from "./plainObjectRenderer";

export function renderPieChart( segments, options = {} ){
    const config = {size: 20, ...options}

    let r = config.size / 2
    const g = new Konva.Group({
        x: options.x ?? 0,
        y: options.y ?? 0,
        width: config.size,
        height: config.size
    })

    const total = segments.map(d=>d?.count ?? 0).reduce((a,c)=>a+c,0)
    const scale = total ? (360 / total) : 0


    let a = 0
    let idx = 0
    let colors = options.colors ?? options.theme?.palette?.categoryColors ?? categoryColors
    const renderContextId = options.renderContextId
    const allocationField = options.allocationField

    g.add(new Konva.Circle({
        x: r,
        y: r,
        radius: r,
        fill: "white",
        shadowEnabled: true,
        shadowBlur: 6,
        shadowColor: "#999",
        shadowOpacity: 0.6,
        shadowOffsetX: r * 0.015,
        shadowOffsetY: r * 0.02
    }))

    for( const s of  segments){

        const degs = scale * s.count
        const renderIdx = s.renderIdx ?? s.order_idx ?? s.idx ?? idx
        var wedge = new Konva.Wedge({
            x: r,
            y: r,
            radius: r,
            angle: degs,
            fill: s.color ?? colors[idx % colors.length],
            //stroke: 'black',
            //strokeWidth: 1,
            strokeScaleEnabled: false,
            rotation: 270 + a,
            name: "cell clickable",
            id: `0-${renderIdx}`,
          });
        if (renderContextId) {
            wedge.attrs.renderContextId = renderContextId;
        }
        const wedgeData = {};
        const entryField = s.allocationField ?? allocationField;
        if (entryField !== undefined) {
            const allocationIdx = s.allocationIdx ?? s.idx;
            wedgeData.allocationField = entryField;
            wedgeData.allocationIdx = allocationIdx;
            wedgeData.allocationPos = renderIdx;
            if (allocationIdx !== undefined && allocationIdx !== null) {
                wedgeData.allocationId = `${entryField}:${allocationIdx}`;
            }
        }
        if (options.cellId) {
            wedgeData.cellId = options.cellId;
        }
        if (Object.keys(wedgeData).length > 0) {
            wedge.attrs.data = wedgeData;
        }
        g.add(wedge)
        a += degs
        idx++
    }

    return g

}
